// parse-link-header が require('querystring') する Node組み込みモジュールの代替。
// ブラウザの URLSearchParams で qs.parse() 相当だけを提供する。
export function parse(
  queryString: string | null | undefined,
): Record<string, string> {
  const result: Record<string, string> = {};
  if (!queryString) return result;

  for (const [key, value] of new URLSearchParams(queryString)) {
    result[key] = value;
  }
  return result;
}
